import router from '@R';
import store from '@VX/store';

export const goRoute = (stage, next = null) => {
    let { user } = store.state.Enrolment;
    const options = {
        name: getRouteFromStageName(stage),
        params: {
            user
        }
    };
    if (next) {
        next(options);
    } else {
        router.push(options);
    }
};

export const notAuthenticated = next => {
    next({
        name: 'login',
        params: {
            flash: {
                message: $gettext('Please login or register before enrolling')
            }
        }
    });
};

export const finishedEnrolment = (user, next) => {
    next({
        name: 'enrolment-success',
        params: {
            user
        }
    });
};

export const notVerified = (email, next) => {
    store.commit('Auth/email', email);
    next({ name: 'verify-account' });
};

// Stackoverflow assistance
// https://stackoverflow.com/a/1811003
// Original: return /8|3|5|10/.test(--m) ? 30 : m==1 ? (!(y%4)&&y%100)||!(y%400) ? 29 : 28 : 31;
const daysInMonth = (m, y) => {
    const yearBy4 = y % 4;
    const yearBy100 = y % 100;
    const yearBy400 = y % 400;

    // Is September, April, June, November
    if (/8|3|5|10/.test(--m)) {
        return 30;
    } else {
        // Is not February
        if (m !== 1) {
            return 31;
        // Is leap year
        } else if (
            (yearBy4 === 0 && yearBy100 === 0) && yearBy400 === 0
            || (yearBy4 === 0 && yearBy100 !== 0)
        ) {
            return 29;
        // Is not leap year
        } else {
            return 28;
        }
    }
}

export const getDaysInMonth = (m, y) => {
    const month = parseInt(m, 10),
        year = y ? parseInt(y, 10) : 2000;

    return daysInMonth(month, year);
};

const validForHomeAddress = user =>
    user.hasOwnProperty('mobile') &&
    user.mobile !== undefined &&
    user.mobile !== null;

const validForBillingAddress = user =>
    validForHomeAddress(user) &&
    user.hasOwnProperty('home_street') &&
    user.home_street !== undefined &&
    user.home_street !== null;

const validForSubscription = user =>
    validForBillingAddress(user);

const validForConfirmation = user =>
    validForSubscription(user) &&
    user.hasOwnProperty('profile') &&
    user.profile &&
    user.profile.enrolment_purchase_option &&
    typeof user.profile.enrolment_purchase_option === 'string';

const validForPayment = user => validForConfirmation(user);

const checkCurrentStage = (currentStage, user) => {
    const { stages } = store.state.Enrolment;
    let stage = null;

    switch (currentStage) {
        case 0:
            // Users who are just starting enrolment are
            // permitted to access the first stage of enrolment
            // and the register stage again
            stage = stages[0];
            break;
        case 1:
            // Users who are just starting enrolment are
            // permitted to access the first stage of enrolment
            // and the register stage again
            stage = stages[1];
            break;
        case 2: // HomeAddress
            if (validForHomeAddress(user)) {
                stage = stages[2];
            }
            break;
        case 3: // BillingAddress
            if (validForBillingAddress(user)) {
                stage = stages[3];
            }
            break;
        case 4: // Subscription
            if (validForSubscription(user)) {
                stage = stages[4];
            }
            break;
        case 5: // Confirmation
            if (validForConfirmation(user)) {
                stage = stages[5];
            }
            break;
        case 6: // Payment
            if (validForPayment(user)) {
                stage = stages[6];
            }
            break;
    }

    return stage;
};

export const permittedForStage = (user, to) => {
    let { stages } = store.state.Enrolment;
    let onStage = getStageFromRouteName(to.name);
    const currentStage = stages.indexOf(onStage);

    // Users who finished enrolment are allowed to access the last stage.
    // (this check is necessary as we null the current_stage field on completion)
    if (user.profile.finished_enrolment && isLastStage(to)) {
        return { go: 'Success' };
    }

    if (currentStage !== -1) {
        const goStage = checkCurrentStage(currentStage, user);
        return { go: goStage, on: onStage };
    } else {
        return null;
    }
};

export const getRouteFromStageName = stage => {
    return (
        'enrolment-' +
        stage.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()
    );
};

export const isLastStage = to => {
    let { stages } = store.state.Enrolment;

    return getStageFromRouteName(to.name) == stages[stages.length - 1];
};

export const getStageFromRouteName = route =>
    route
        .replace(/Item:/g, '')
        .split('-')
        .map(part => part[0].toUpperCase() + part.slice(1))
        .join('')
        .replace('Enrolment', '');

/**
 * Prepends 0 to numbers under 10 for 'dd' date formatting.
 */
export const twoDigits = int => ('0' + int).slice(-2);

/**
 * Get the payment frequency string for a purchase option based on the "purchase option number" field which represents how many months between payments
 */
export const paymentFrequencyForPurchaseOption = months => {
    if (months == null || months === 0) {
        return $gettext('one-off');
    } else if (months == 12) {
        return $gettext('yearly');
    }

    let translated = $ngettext('monthly', '%{ months } monthly', months);

    return $gettextInterpolate(translated, { months: months });
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/enrolment.js